<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Resume</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div class="mt-5"><br /><br /><br /><br /><br /></div>
    </div>
    <CCard class="custom-card h-100 mx-auto" style="max-width: 500px;">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <h5 class="text-left mt-4 d-flex d-sm-none text-black bold">
                Teacher Area of Expertise
              </h5>
              <CRow>
                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="text-center custom-width-lg p-0 mb-3">
                    <CRow class="justify-content-center p-0 mt-2">
                      <CCol sm="12" lg="12">
                        <CRow>
                          <CCol sm="12" lg="12">
                            <div class="mt-3 mb-4 text-left"></div>
                            <CTextarea
                              filled
                              auto-grow
                              rows="10"
                              row-height="30"
                              shaped
                              class="mt-2"
                              v-model="areaExpertName"
                              placeholder="Enter your area of expertises"
                            />
                          </CCol>
                        </CRow>
                        <div class="mt-4">
                          <CButton
                            color="info"
                            class="custom-btn ml-2 mr-2 mb-2"
                            @click="SaveResume"
                            block
                            >Update</CButton
                          >
                        </div>
                        <hr />
                      </CCol>
                    </CRow>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>     
<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);
import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

export default {
  name: "Login",
  components: {
    PulseLoader
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      areaExpertName: "",
      teacherAreasOfExpertise: {}
    };
  },
  async mounted() {
    await this.GetAreaofExpertise();
  },

  methods: {
    async GetAreaofExpertise() {
      this.$API
        .get(
          this.$TeacherAreasOfExpertise + "?userId=" + this.$route.query.userId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.teacherAreasOfExpertise = response.data;
            this.areaExpertName = this.teacherAreasOfExpertise.Content;
          } else {
            this.teacherAreasOfExpertise = null;
            this.areaExpertName = "none";
          }
        });
    },
    SaveResume() {
      this.UpdateAcademicProfile();
    },
    UpdateAcademicProfile() {
      const formData = new FormData();
      formData.append("userId", this.$route.query.userId);
      formData.append("content", this.areaExpertName);

      return this.$API
        .post(this.$InsertUpdateAreaofExpertises, formData, {
          withCredentials: true
        })
        .then(response => {
          this.GoToPreviousPage();
          if (response.status == 200 && response.data != null) {
            this.$dialog
              .alert("You have successfully save the professional profile")
              .then(function(dialog) {
                console.log("Closed");
              });
          }
        })
        .catch(error => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
    GoToPreviousPage() {
      this.$router.push(
        "/ProfessionalProfile?userId=" + this.$route.query.userId
      );
    }
  }
};
</script>
